<div class="grid no-select">
  <app-prisma-xs-widget-grid
    #grid
    [allArticles]="allArticles"
    [ngClass]="{'cursor-no-drop': !availablePlacingGrabbingArticleOnGrid }"
    [rows]="rows"
    [columns]="cols"
    [showGrid]="showGrid"
    [placedKits]="placedKits"
    (widgetPositionChange)="onWidgetChange($event)"
    (mouseenter)="enterOnGrid()"
    (mouseleave)="leaveGrid()"
    (contextmenu)="contextMenu($event, menuContextComponentEl?.userMenu, true)">
    @for (article of widgets; track article) {
      <app-prisma-xs-widget
        [position]="article?.widget"
        [movable]="!(placedKits[$index]?.status | isProductDeprecated) && isEditableProject && placedKits[$index]?.deviceId"
        [selected]="article?.widget?.selected"
        [resizable]="article?.widget?.selected && !article?.rules?.kit?.noResize && isEditableProject && placedKits[$index]?.deviceId"
        [maxRows]="article?.maxRows"
        [maxColumns]="article?.maxFields"
        [minColumns]="article?.minFields"
        [minRows]="article?.minRows"
        [article]="article"
        [widgetUUID]="article?.uuid"
        [productType]="article?.productType"
        [title]="placedKits[$index]?.description"
        [widgetAddInProgress]="!placedKits[$index]?.deviceId"
        (click)="onSelectWidget(article)"
        (dragstart)="onDragStart(article)"
        (positionChange)="onWidgetPositionChange($event, $index, placedKits[$index]?.productType)"
        (contextmenu)="contextMenu($event, menuContextComponentEl?.userMenu, placedKits[$index]?.deviceId, article); $event.stopPropagation()">
        <div class="widgetContent">
          @if (placedKits[$index]?.pictures) {
            <div class="imagePlaceholder">
              <img [alt]="placedKits[$index]?.ref" (error)="onError(covers)" #covers class="position-absolute kit-image cover-image" [src]="placedKits[$index]?.pictures | widgetImage:0"/>
              @if (showCovers && placedKits[$index]?.rules?.hasCover) {
                <img [alt]="placedKits[$index]?.ref" class="position-relative kit-image" [src]="placedKits[$index]?.pictures | widgetImage:1"/>
              }
              <app-ui-enclosure-grid-reference
                [ref]="placedKits[$index]?.ref"
                [zoomLevel]="zoomLevel"
                [selected]="article?.widget?.selected">
              </app-ui-enclosure-grid-reference>
            </div>
          } @else {
            <div class="imagePlaceholder" [title]="placedKits[$index]?.ref" [style.background-image]="'url(' + placedKits[$index]?.picture2D + ')'">
              <app-ui-enclosure-grid-reference
                [ref]="placedKits[$index]?.ref"
                [zoomLevel]="zoomLevel"
                [selected]="article?.widget?.selected">
              </app-ui-enclosure-grid-reference>
            </div>
          }
        </div>
      </app-prisma-xs-widget>
    }
  </app-prisma-xs-widget-grid>
</div>

<app-prisma-xs-menu-context
  #menuContextComponent
  [contextMenuActionType]="contextMenuActionType"
  [articleToCopy]="!!articleCopied"
  [isEditableProject]="isEditableProject"
  (contextMenuActionData)="contextMenuAction($event)"
  >
</app-prisma-xs-menu-context>
